var map = {
	"./341.png": "BaVG",
	"./435.png": "Zctv",
	"./452.png": "H9iM",
	"./479.png": "gZT8",
	"./496.png": "i2jZ",
	"./600.png": "6XBZ",
	"./601.png": "LOW5",
	"./609.png": "U4TW",
	"./700.png": "3YCW",
	"./737.png": "R8ej",
	"./800.png": "3GpL",
	"./855.png": "2xR4",
	"./874.png": "RyKA",
	"./886.png": "aFiN",
	"./907.png": "wlqy",
	"./939.png": "1FiM",
	"./Anomaly.png": "Tnhp",
	"./Common.png": "RBCi",
	"./Legacy.png": "tWyS",
	"./Maverick.png": "xKJE",
	"./Rare.png": "Hxsr",
	"./Special.png": "Txo9",
	"./Uncommon.png": "DG3v",
	"./action.png": "bt0k",
	"./artifact.png": "Sbr6",
	"./creature.png": "vlC/",
	"./decals/santa.png": "QuYC",
	"./decklist-h.png": "x6Jp",
	"./decklist.png": "YtJz",
	"./evil-twin.png": "OL3R",
	"./idback_blanks/cardback_1.png": "j2GH",
	"./idback_blanks/cardback_1_evil.png": "Pw8M",
	"./idback_blanks/cardback_2.png": "yUaS",
	"./idback_blanks/cardback_2_evil.png": "yFfM",
	"./idback_blanks/cardback_3.png": "yArU",
	"./idback_blanks/cardback_3_evil.png": "KFyY",
	"./idback_blanks/cardback_4.png": "k7O2",
	"./idback_blanks/cardback_4_evil.png": "YBqQ",
	"./idback_blanks/cardback_5.png": "GH4m",
	"./idback_blanks/cardback_5_evil.png": "YCs7",
	"./idback_blanks/cardback_6.png": "06IJ",
	"./idback_blanks/cardback_6_evil.png": "lFvV",
	"./idback_blanks/cardback_7.png": "TTBP",
	"./idback_blanks/cardback_7_evil.png": "FnXZ",
	"./idback_blanks/cardback_halloween.png": "2UvA",
	"./idback_houses/brobnar.png": "JNIA",
	"./idback_houses/dis.png": "YCGS",
	"./idback_houses/ekwidon.png": "DiW/",
	"./idback_houses/geistoid.png": "KoUc",
	"./idback_houses/logos.png": "C/ED",
	"./idback_houses/mars.png": "znGR",
	"./idback_houses/redemption.png": "n9uo",
	"./idback_houses/sanctum.png": "hxKe",
	"./idback_houses/saurian.png": "K3NA",
	"./idback_houses/shadows.png": "JDvZ",
	"./idback_houses/skyborn.png": "W32I",
	"./idback_houses/staralliance.png": "9lc2",
	"./idback_houses/unfathomable.png": "pK9l",
	"./idback_houses/untamed.png": "NKPI",
	"./prophecy.png": "5oKA",
	"./tco.png": "vYgI",
	"./the tide.png": "fZXp",
	"./tide.png": "xuzM",
	"./token creature.png": "Q3VG",
	"./upgrade.png": "J42P"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mgig";